import { http } from "@/api";

/**
 * Solicita informações do elemento pai da unidade geradora (podendo ser Bay ou HydroPowerPlant).
 * @param {Number} monitoringElementId Id do elemento de monitoramento tipo unidade geradora.
 * @returns Objecto com informação do pai da unidade geradora.
 */
const GetParent = function(monitoringElementId)
{
	return http.get(`/HydroGeneratingUnits/${monitoringElementId}/parent`);
};

/**
 * Solicita os pontos de medição da unidade geradora.
 * @param {Number} monitoringElementId Id do elemento de monitoramento tipo unidade geradora.
 * @returns Array de pontos de medições com status.
 */
const GetMeasurements = function(monitoringElementId = 0)
{
	return http.get(`/HydroGeneratingUnits/${monitoringElementId}/measurements`);
};

/**
 * Solicita as notificações ocorridas para a unidade geradora.
 * @param {Number} monitoringElementId Id do elemento de monitoramento tipo unidade geradora
 * @param {Number} startDateTime Data;hora de início.
 * @param {Number} endDateTime Dtaa/hora de fim.
 * @returns Array de notificações ocorridas para a unidade geradora.
 */
const GetNotificationsLogs = function(monitoringElementId, startDateTime, endDateTime)
{
	return http.get(`/HydroGeneratingUnits/
		${monitoringElementId }/notifications-log?startDateTime=
		${startDateTime}&endDateTime=
		${endDateTime}`);
};

/**
 * Solicita as configurações estáticas da unidade geradora.
 * @param {Number} monitoringElementId Id do elemento de monitoração da unidade geradora.
 * @returns Objeto com as configurações estáticas da unidade geradora.
 */
const Get = function(monitoringElementId = 0)
{
	return http.get(`/HydroGeneratingUnits/${monitoringElementId}`);
};

export default
{
	Get,
	GetParent,
	GetMeasurements,
	GetNotificationsLogs
};